export const ENDPOINT = process.env.NODE_ENV === 'production' ? 'https://app.moin.bz' : 'http://localhost:3000';
export const MOIN_SETTING_NAME = 'moinSetting';
export const WINDOW_WIDGET = 'moinWidget';
export const CDN_ENDPOINT = process.env.NODE_ENV === 'production' ? 'https://cdn.moin.bz' : 'http://localhost:4000';

export type MoinSettingType = {
    hideButtonOnMobileDevice: boolean
};
